import { render, staticRenderFns } from "./domainMix.vue?vue&type=template&id=26564cb8"
import script from "./domainMix.vue?vue&type=script&lang=js"
export * from "./domainMix.vue?vue&type=script&lang=js"
import style0 from "./domainMix.vue?vue&type=style&index=0&id=26564cb8&prod&lang=scss&scope=true"
import style1 from "./domainMix.vue?vue&type=style&index=1&id=26564cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports